// assets
import { AdminIcon } from 'components/icons/sidebarIcons';
import { Campaign, LocalActivity, ManageAccounts, Style, Try, EditCalendar, SettingsSuggest, AutoAwesome, AccountBalance } from '@mui/icons-material';

// constant
export const icons = {
    Campaign,
    LocalActivity,
    ManageAccounts,
    Style,
    Try,
    EditCalendar,
    SettingsSuggest,
    AutoAwesome,
    AccountBalance
};

const administration = {
    id: 'admin',
    title: 'side_menu.administration',
    type: 'group',
    roles: ['admin', 'superadmin', 'it', 'sales'],
    collapse: false,
    icon: 'SettingsSuggest', //icons.SettingsSuggest,
    children: [
        {
            id: 'administration-manage-account',
            title: 'side_menu.manage_account',
            type: 'item',
            url: 'admin/manage-accounts',
            icon: 'ManageAccounts', //icons.ManageAccounts,
            breadcrumbs: false,
            roles: ['admin', 'superadmin', 'it', 'sales'],
        },
        {
            id: 'administration-manage-announcement',
            title: 'side_menu.manage_announcement',
            type: 'item',
            url: 'admin/manage-announcements',
            icon: 'Campaign', //icons.Campaign,
            breadcrumbs: false,
            roles: ['admin', 'superadmin', 'it'],
        },
        {
            id: 'administration-manage-subscription-plan',
            title: 'side_menu.manage_subscription_plan',
            type: 'item',
            url: 'admin/manage-subscription-plans',
            icon: 'Style', //icons.Style,
            breadcrumbs: false,
            roles: ['admin', 'superadmin', 'it'],
        },
        {
            id: 'administration-manage-coupon',
            title: 'side_menu.manage_coupons',
            type: 'item',
            url: 'admin/manage-coupons',
            icon: 'LocalActivity', //icons.LocalActivity,
            breadcrumbs: false,
            roles: ['admin', 'superadmin', 'it', 'sales'],
        },
        {
            id: 'administration-manage-feedback',
            title: 'side_menu.manage_feedbacks',
            type: 'item',
            url: 'admin/manage-feedbacks',
            icon: 'Try', //icons.Try,
            breadcrumbs: false,
            roles: ['admin', 'superadmin'],
        },
        {
            id: 'administration-manage-deadline',
            title: 'side_menu.manage_deadlines',
            type: 'item',
            url: 'admin/manage-deadlines',
            icon: 'EditCalendar', //icons.EditCalendar,
            breadcrumbs: false,
            roles: ['admin', 'superadmin'],
        },
        {
            id: 'administration-manage-smart-phrases',
            title: 'side_menu.manage_smart_phrases',
            type: 'item',
            url: 'admin/manage-smart-phrases',
            icon: 'AutoAwesome', //icons.AutoAwesome,
            breadcrumbs: false,
            roles: ['admin', 'superadmin', 'it'],
        },
        {
            id: 'administration-manage-foundations',
            title: 'side_menu.manage_foundations',
            type: 'item',
            url: 'admin/manage-foundations',
            icon: 'AccountBalance', //icons.AccountBalance,
            breadcrumbs: false,
            roles: ['admin', 'superadmin'],
        },
        /*{
            id: 'administration-manage-plans',
            title: 'side_menu.manage_plans',
            type: 'item',
            url: 'main/admin/manage-plans',
            icon: 'IconBusinessplan', //icons.IconBusinessplan,
            breadcrumbs: false,
            roles: ['admin', 'superadmin', 'it'],
        }*/
    ]
};

export default administration;
